import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {

    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
});

// Attaches the admin's Sanctum token, when one is stored, to every request
// made through this instance. Public endpoints simply ignore the extra
// header (they have no auth:sanctum middleware), so this doesn't affect any
// of the app's existing unauthenticated API calls.
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosInstance;